<template>
<div>
  <div v-if="loading">
    <b-spinner variant="primary"></b-spinner>
  </div>
  <div v-if="instructors.length > 0">
    <ul class="list-unstyled">
      <b-media tag="li" v-for="i in instructors" :key="i.user.email" class="mt-3">
        <template v-slot:aside>
          <user-avatar-lazy :user="i.user" :size="64"></user-avatar-lazy>
        </template>
        <h5 class="mt-0 mb-1">{{i.user.name}}</h5>
        <a :href="'mailto:' + i.user.email">{{i.user.email}}</a>
        <p class="mb-0">{{i.user.introduction}}</p>
      </b-media>
    </ul>
  </div>
  <div v-if="!loading && instructors.length == 0">
    <b-media>
      <template v-slot:aside>
        <b-img blank blank-color="#abc" width="64" alt="placeholder"></b-img>
      </template>
      <h5 class="mt-0 mb-1">Hawk Ridge Systems</h5>
      <p class="mb-0">Hawk Ridge Systems is your official SOLIDWORKS and CAMWORKS training provider for the United States and Canada.
        Our courses are available in our state of the art training labs, online, self-paced, or onsite at your facility.
        We offer a comprehensive range of beginning, advanced, and design specialty courses.</p>
      <p class="mb-0">The instructors at Hawk Ridge Systems know what it takes to provide the best learning experience for students.</p>
    </b-media>
  </div>
</div>
</template>

<script>
import Api from '@/api/Api'
import UserAvatarLazy from './UserAvatarLazy'

export default {
  props: [ 'id' ],
  data () {
    return {
      loading: true,
      instructors: []
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      var vm = this
      vm.loading = true
      Api().get(`Course/${vm.id}/Users?type=Instructor`)
        .then((r) => {
          vm.instructors = r.data.filter(x => x.isVisible).sort((a, b) => {
            return a.sortOrder - b.sortOrder
          })
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          vm.loading = false
          vm.$emit('instructorsLoaded', vm.instructors)
        })
    }
  },
  components: {
    UserAvatarLazy
  }
}
</script>

<style>

</style>
